import * as Yup from 'yup'
import React from 'react'
import { AuthContainer } from '../../container/AuthLayout.styled'
import { FormError, FormWrapper, AuthButton, AuthForm, AuthInput, AuthLabel, AuthHeader, FormHeader } from '../Auth.styled'
// import {useNavigate} from 'react-router-dom'
import { 
    // useDispatch,
    useSelector
} from 'react-redux'
import { useFormik } from 'formik'

const ForgotPassword = () => {
//   const navigate = useNavigate()

  const { loading, error } = useSelector(
    (state) => state.auth
  )

//   const dispatch = useDispatch()

  const initialValues = {
    email: ""
  }

  const onSubmit = (values) => {
    // dispatch(loginUser(values)).unwrap().then(res => navigate("/"))
  }

  const validationSchema = Yup.object({
    email: Yup.string().email().required("Email is required"),
  })

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  return (
    <AuthContainer>
      <AuthHeader>Forgot Password</AuthHeader>
          <AuthForm onSubmit={formik.handleSubmit}>
            <FormHeader>Enter Your Email</FormHeader>
            {error && <FormError>{error}</FormError>}
            <FormWrapper>
              <AuthLabel>Email</AuthLabel>
              <AuthInput 
                type="email"
                name="email"
                placeholder="Email"
                onChange={formik.handleChange}
                value={formik.values.email}
              />
              {formik.errors.email ? <FormError>{formik.errors.email}</FormError> : null}
            </FormWrapper>
            <AuthButton type='submit' disabled={loading}>{loading ? "Loading" : "Continue"}</AuthButton>
          </AuthForm>
    </AuthContainer>
  )
}

export default ForgotPassword;